module.exports = __webpack_public_path__ + "img/BountyHunter.031d7c38.png";